export default {
  'runCode.mapping': 'Response mapping',
  'runCode.addMapping': 'Add mapping',
  'runCode.noMappings': 'No response mappings yet.',
  'runCode.form.responseProperty': 'Response property',
};
